import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyD9W_n8hv4_tVg4nPfYwHcCzhQffuNjOtk",
    authDomain: "yatstream-e4ec8.firebaseapp.com",
    projectId: "yatstream-e4ec8",
    storageBucket: "yatstream-e4ec8.firebasestorage.app",
    messagingSenderId: "778876192237",
    appId: "1:778876192237:web:c5e57fa3ec0bbf9dec13e4",
    measurementId: "G-H1S1S9L02Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
    prompt: 'select_account'
});

export { auth, googleProvider, db, storage };
